import genericRule from '../../namespace/relation/willCreate_namespace_relation';

export default {
    ...genericRule,
    excludedNamespaceRelations: [],
    namespace: 'application',
    relation: 'reset'
};
